import React from 'react';
import { useSignupExtraDetails } from 'hooks/useSignupExtraDetails';

/**
 * Component that processes signup details saved in localStorage.
 * This component should be rendered inside the AuthProvider so it runs for all authenticated users.
 */
export const SignupDataProcessor: React.FC = () => {
  useSignupExtraDetails();

  // This component doesn't render anything visible
  // It just runs the hook on mount when user is authenticated
  return null;
};